<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<template>
  <div>
    <label
      v-for="languageOption in languages"
      :key="languageOption.code"
      class="c-language"
      tabindex="0"
      @keydown.enter.space="onSelect(languageOption.code)"
      @click="onSelect(languageOption.code)"
    >
      <input v-model="selectedLanguage" class="c-language__radio" type="radio" :value="languageOption.code" />
      <span class="c-language__title">{{ $t(languageOption.title) }}</span>
      <span class="c-language__circle"></span>
    </label>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import useLocalization from '@/services/useLocalization';

const { locale, setLocale } = useLocalization();

const emit = defineEmits<{
  change: [language: string];
}>();

const languages = computed(() =>
  locale.value === 'en-GB'
    ? [{ code: 'en-GB', title: 'English' }]
    : [
        { code: 'nn-NO', title: 'HEADER.LANG_NN' },
        { code: 'nb-NO', title: 'HEADER.LANG_NB' },
      ],
);

const selectedLanguage = computed(() => locale.value);

const onSelect = (language: string) => {
  setLocale(language);
  emit('change', language);
};
</script>
